import { getUserConfig } from '../components/config/LocalConfig';
import { useAuth } from '../contexts/AuthContext';

export function useUserConfig() {
    const { user } = useAuth();
    return getUserConfig(user?.userId);
}
